export const faqs = [
  {
    q: "网站黑料里的信息是从哪里来的？",
    a: "主要来自用户主动提交的投诉线索、公开可查的消费反馈，以及平台公示的处理记录。我们对线索做去重与交叉核实后，按照风险等级收录，并在详情页标注收录与更新时间。"
  },
  {
    q: "被收录的平台就一定有问题吗？",
    a: "不一定。名单分为高危、中危与观察三个等级。观察等级代表线索有限、仍有待核实，仅作为交易前的参考提醒，不构成对任何主体的定性结论。"
  },
  {
    q: "普通人怎么快速判断一个网站靠不靠谱？",
    a: "先看主体信息是否清晰、售后渠道是否公开、支付方式是否规范；再看价格是否明显低于市场；最后在站内搜索平台名称，查看是否已有同类反馈。三点都异常时，建议暂缓大额交易。"
  },
  {
    q: "已经在某个平台投入资金了怎么办？",
    a: "立即停止追加投入，尤其是任何形式的解冻费与保证金。保存转账凭证、聊天记录与页面截图，尽快联系银行或支付平台尝试止付，并到就近派出所报案。"
  },
  {
    q: "维权时最有效的证据有哪些？",
    a: "支付流水、订单记录、沟通记录和平台页面截图是核心四类。建议按时间和金额整理成一份表格，注明每笔支出对应的渠道与当前状态，便于向多个渠道重复提交。"
  },
  {
    q: "我想提交一条黑料线索，需要提供什么？",
    a: "请提供平台名称或域名、问题类型、发生时间、经过描述，以及可佐证的截图或凭证。信息越完整，核实速度越快。请勿提交包含他人隐私的内容。"
  },
  {
    q: "发现名单里的信息有误怎么办？",
    a: "可以通过联系我们页面提交更正申请，附上相关说明与证明材料。我们会在核实后及时更新或下架相应记录。"
  },
  {
    q: "避雷哨收费吗？",
    a: "查询与阅读完全免费。我们不参与任何平台的推广，也不提供收费删帖服务，任何以本站名义索要费用的行为均与本站无关。"
  }
];

export const siteReviews = [
  {
    name: "林先生",
    role: "网购用户",
    content:
      "准备在一家没听过的商城下单前查了一下，发现已经有人反馈发货异常，果断换了一家，省了好几百。",
    date: "2026-08-22"
  },
  {
    name: "周女士",
    role: "宝妈",
    content:
      "给家人找兼职的时候看到刷单类的提醒，孩子差点上当，这些识别要点写得很实在，不是空话。",
    date: "2026-08-05"
  },
  {
    name: "陈同学",
    role: "在校学生",
    content:
      "维权指南里的流程很清晰，按着一步步走，最后平台介入了，退款也处理好了。",
    date: "2026-07-19"
  },
  {
    name: "王先生",
    role: "自由职业",
    content:
      "预付卡那篇提醒很到位，之前我就是冲动充了一大笔，现在改成小额多次，心里踏实多了。",
    date: "2026-06-30"
  }
];

export const sitePrinciples = [
  {
    icon: "ri-shield-check-line",
    title: "线索先核实再收录",
    desc: "每一条记录都会做去重与交叉比对，信息不足或无法验证的线索会标注为观察等级，不夸大风险。"
  },
  {
    icon: "ri-scales-3-line",
    title: "只陈述可查证事实",
    desc: "我们描述用户反馈的现象与时间线，不使用主观定性用语，也不代替任何部门作出结论。"
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新记录状态",
    desc: "平台情况会变化，记录同样会更新。已处理或已恢复的记录会标注最新状态，避免信息过期。"
  },
  {
    icon: "ri-lock-2-line",
    title: "保护提交者隐私",
    desc: "提交线索时提供的联系方式仅用于核实，不会公开展示，也不会用于其他用途。"
  }
];

export const contactChannels = [
  {
    icon: "ri-mail-send-line",
    title: "线索与更正",
    value: "tips@bileishao.example",
    desc: "提交风险线索、更正申请或补充材料"
  },
  {
    icon: "ri-customer-service-2-line",
    title: "内容合作与反馈",
    value: "hello@bileishao.example",
    desc: "内容建议、合作咨询与使用反馈"
  },
  {
    icon: "ri-time-line",
    title: "处理时间",
    value: "工作日 24 小时内",
    desc: "线索核实结果将通过邮件回复"
  }
];